import { useContext } from 'react';

import { ProductVersionsContext } from '../context/product-versions-provider';

export const useProductVersions = () => {
  const context = useContext(ProductVersionsContext);

  if (!context) {
    throw new Error(
      'useProductVersion must be used within a ProductVersionsProvider',
    );
  }

  return context;
};
